import React, { useState, useEffect } from "react";
import "../assets/css/alert.css";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const AlertModal = () => {
  const [popup, setPopup] = useState(true);

  useEffect(() => {
    const showPopup = setInterval(() => {
      setPopup(!popup);
    }, 30000);

    return () => {
      clearInterval(showPopup);
    };
  });

  return (
    <div className={`alert-container ${popup ? "show" : ""}`}>
      <div>
        <div>
          Enrollment For NT bootcamp Cohort 1 ends
          <strong> 5th May 2025</strong>
        </div>
        <button className="btn5">
          <Link to="/bootcamp/#academy">Learn More</Link>
        </button>
      </div>
      <span onClick={() => setPopup(false)} className="close lf">
        <X />
      </span>
    </div>
  );
};

export default AlertModal;
